import React from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../helpers";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { FormButtons, TextError } from "../../../components";

export const AddEditTarget = observer((props: any) => {
  const rootStore = useStore();
  const params = useParams();
  const { voterReachOutStore } = rootStore;
  const { TargetFormValue, formType } = voterReachOutStore;
  const projectId = params.projectid;

  const initialValues = {
    name: TargetFormValue?.name || "",
    text: TargetFormValue?.text || "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    text: Yup.string().required("Message is required"),
  });

  const createTarget = async (values: any) => {
    const payload = {
      projectid: projectId,
      name: values.name,
      type: "static",
      text: values.text,
      src: {},
      more: {},
    };

    const res = await voterReachOutStore.create_reachout_target(payload);
    if (res?.status === 200) {
      toast.success("Target created successfully");
      // Force refresh by clearing cache and refetching
      voterReachOutStore.lastReachOutTargetPayload = null;
      props.getReachOutTarget();
      voterReachOutStore.set_isEditOverlay(false);
    }
  };

  const updateTarget = async (values: any) => {
    const payload = {
      id: TargetFormValue.id,
      projectid: projectId,
      type: "static",
      name: values.name,
      text: values.text,
      src: {},
      more: {},
    };

    const res = await voterReachOutStore.update_reachout_target(payload);
    if (res?.status === 200) {
      toast.success("Target updated successfully");
      // Force refresh by clearing cache and refetching
      voterReachOutStore.lastReachOutTargetPayload = null;
      props.getReachOutTarget();
      voterReachOutStore.set_isEditOverlay(false);
    }
  };

  const handleSubmit = async (values: any) => {
    if (formType === "new") {
      await createTarget(values);
    } else {
      await updateTarget(values);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      enableReinitialize
    >
      {({ values }) => (
        <Form
          className="space-y-6 rounded-[28px] border border-slate-200 bg-white p-5 text-left shadow-[0_20px_50px_-30px_rgba(15,23,42,0.45)] sm:p-7"
          placeholder={undefined}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        >
          <div className="space-y-6">
            <div className="space-y-2">
              <label
                htmlFor="name"
                className="block text-sm font-semibold text-slate-700"
              >
                Target name <span className="text-red-500">*</span>
              </label>
              <Field
                type="text"
                id="name"
                name="name"
                placeholder="e.g. Community volunteers"
                className="w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700 shadow-sm transition-all placeholder:text-slate-400 focus:border-emerald-500 focus:bg-white focus:outline-none focus:ring-4 focus:ring-emerald-100"
              />
              <ErrorMessage name="name" component={TextError} />
            </div>

            <div className="space-y-2">
              <label
                htmlFor="text"
                className="block text-sm font-semibold text-slate-700"
              >
                Phone numbers <span className="text-red-500">*</span>
              </label>
              <p className="text-xs text-slate-500">
                Add the phone numbers you want included in this target.
              </p>
              <Field
                as="textarea"
                id="text"
                name="text"
                placeholder="Enter phone numbers..."
                className="h-40 w-full resize-y rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700 shadow-sm transition-all placeholder:text-slate-400 focus:border-emerald-500 focus:bg-white focus:outline-none focus:ring-4 focus:ring-emerald-100"
              />
              <ErrorMessage name="text" component={TextError} />
            </div>
          </div>

          <div className="pt-2">
            <FormButtons
              disabled={!values.name.trim() || !values.text.trim()}
              onSave={() => {}}
              onCancel={() => voterReachOutStore.set_isEditOverlay(false)}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
});
